export default __webpack_public_path__ + "static/media/ternium.456886e1.png";